import { G as e, K as t, d as n, ft as r, i, m as a, n as o, p as s, q as c, s as l, t as u, u as d } from "./chunk-client-WKUGyy6G.js";
import { t as f } from "./chunk-Configure-ByHz2hue.js";
import { i as p, n as m, r as h, t as g } from "./chunk-routing-Hc8Taf1E.js";
//#region src/entry/collection-algolia.tsx
e();
var { appId: _, searchKey: v, indexName: y } = r, b = "shopify", x = o(_, v), S = {
	router: a({
		cleanUrlOnDispose: !1,
		push: m
	}),
	stateMapping: {
		stateToRoute(e) {
			let t = e[y]?.page;
			return {
				...g(e[y]),
				page: t && t > 1 ? String(t) : void 0
			};
		},
		routeToState(e) {
			let t = Number(e.page);
			return { [y]: {
				...h(e),
				page: t > 1 ? t : void 0
			} };
		}
	}
};
function C({ onReady: e, onError: r }) {
	let { status: i } = n({ catchError: !0 }), a = c(!1), o = c(!1);
	return t(() => {
		if (i === "loading" || i === "stalled") {
			a.current = !0;
			return;
		}
		a.current && !o.current && (i === "idle" ? (o.current = !0, e()) : i === "error" && (o.current = !0, r()));
	}, [
		i,
		e,
		r
	]), null;
}
function w({ handle: e, title: t, productsPerPage: n, onReady: r, onError: a }) {
	return /* @__PURE__ */ l(s, {
		searchClient: x,
		indexName: y,
		routing: S,
		children: [
			/* @__PURE__ */ l(d, {}),
			/* @__PURE__ */ l(C, {
				onReady: r,
				onError: a
			}),
			/* @__PURE__ */ l(f, {
				filters: `collections:"${e}"`,
				hitsPerPage: n
			}),
			/* @__PURE__ */ l(i.Provider, {
				value: t,
				children: /* @__PURE__ */ l(p, { showPrevious: !0 })
			})
		]
	});
}
async function T(e, t) {
	try {
		let n = new URL(window.location.href);
		n.searchParams.set("view", b);
		let r = await fetch(n).then((e) => e.text()), i = new DOMParser().parseFromString(r, "text/html").getElementById("collection");
		if (!i) throw Error("No #collection in Shopify fallback");
		e.unmount(), document.getElementById("collection-algolia-skeleton")?.remove(), t.replaceWith(i);
	} catch (e) {
		console.error("Algolia collection fallback failed", e);
	}
}
function E() {
	let e = document.getElementById("collection-algolia"), t = e?.dataset.collectionHandle;
	if (!e || !t) return;
	let n = u.createRoot(e);
	n.render(/* @__PURE__ */ l(w, {
		handle: t,
		title: e.dataset.collectionTitle ?? null,
		productsPerPage: Number(e.dataset.productsPerPage) || 16,
		onReady: () => {
			document.getElementById("collection-algolia-skeleton")?.remove(), e.classList.remove("hidden");
		},
		onError: () => T(n, e)
	}));
}
E();
//#endregion
